import { formatInTimeZone } from 'date-fns-tz';

export const BRAZIL_TZ = 'America/Sao_Paulo';

/**
 * Get current date/time formatted for Brazil timezone (for DISPLAY only)
 * DO NOT use .getTime() on the result - use Date.now() for comparisons
 */
export const getBrazilNowFormatted = (format: string = 'yyyy-MM-dd HH:mm:ss'): string => {
  return formatInTimeZone(new Date(), BRAZIL_TZ, format);
};

/**
 * Check if a date has expired (comparing UTC timestamps directly)
 * This is the CORRECT way to check expiration - no timezone manipulation needed
 * @param expiresAt - Date string with timezone info (e.g., '2025-12-15T23:59:59-03:00')
 */
export const isExpired = (expiresAt: Date | string | null): boolean => {
  if (!expiresAt) return false;
  
  const expirationTimestamp = typeof expiresAt === 'string' 
    ? new Date(expiresAt).getTime() 
    : expiresAt.getTime();
    
  return Date.now() > expirationTimestamp;
};

/**
 * @deprecated Use isExpired() instead - this function had timezone bugs
 */
export const isExpiredInBrazil = (expiresAt: Date | string | null): boolean => {
  return isExpired(expiresAt);
};

/**
 * Debug: Get current time info for both UTC and Brazil
 */
export const getDebugTimeInfo = (): { utc: string; brazil: string; timestamp: number } => {
  const now = new Date();
  return {
    utc: now.toISOString(),
    brazil: formatInTimeZone(now, BRAZIL_TZ, 'yyyy-MM-dd HH:mm:ss zzz'),
    timestamp: now.getTime()
  };
};
